import { useEffect } from 'react';
import Cookies from 'universal-cookie';

import { IQueryParams } from 'typescriptDefs';

import { setCookieExpiration } from '.';

const useAddCookiesFromUrlQueryParams = ({ url }: { url?: string | null }): void => {
  useEffect(() => {
    if (url) {
      const queryParams: IQueryParams = { hash: {}, search: {} };

      const cookies = new Cookies();
      const cookieQueryParams = cookies.get('queryParamsSite');

      if (cookieQueryParams?.hash) {
        queryParams.hash = { ...cookieQueryParams.hash };
      }

      if (cookieQueryParams?.search) {
        queryParams.search = { ...cookieQueryParams.search };
      }

      const indexOfHashParams = url.indexOf('#');
      const indexOfSearchParams = url.indexOf('?');

      if (indexOfHashParams > -1) {
        const queryParamString = url.split('#')[1];
        const queryParamsHash = generateObjectFromString(queryParamString);
        queryParams.hash = { ...queryParams.hash, ...queryParamsHash };
      }

      if (indexOfSearchParams > -1) {
        const queryParamString = url.slice(indexOfSearchParams + 1, indexOfHashParams ? indexOfHashParams : url.length);
        const queryParamsSearch = generateObjectFromString(queryParamString);
        queryParams.search = { ...queryParams.search, ...queryParamsSearch };
      }

      if (Object.keys(queryParams.hash).length !== 0 || Object.keys(queryParams.search).length !== 0) {
        const dateExpiry = setCookieExpiration(30);
        cookies.set(
          'queryParamsSite',
          {
            ...queryParams,
            dateSet: new Date(),
          },
          {
            expires: dateExpiry,
          },
        );
      }
    }
  }, []);
};

export default useAddCookiesFromUrlQueryParams;

const generateObjectFromString = (queryParamString: string) => {
  let queryParams = {};

  const paramsSplit = queryParamString.split('&');
  const keyValueSplit = paramsSplit.map((param) => param.split('='));
  keyValueSplit.forEach((keyValue) => {
    queryParams = {
      ...queryParams,
      [keyValue[0]]: decodeURIComponent(keyValue[1]),
    };
  });

  return queryParams;
};
